import { AdditionalFile,
  ApplicationResult,
  Configuration,
  CurrentApplicationUserRolesResult,
  DataSynthesis,
  Internationalizations,
  Node,
  RightsRequest,
  Roles,
  StandardDataDescription } from "../generated/UsedGeneratedTypes";

export class LocalApplicationResult implements ApplicationResult {
  id: string;
  name: string;
  title: string;
  comment: string;
  configFile: string;
  internationalization: Internationalizations;
  data: { [index: string]: StandardDataDescription };
  references: { [index: string]: Node };
  authorizations: { [index: string]: { [P in Roles]?: boolean } };
  referenceSynthesis: DataSynthesis[];
  dataTypes: { [index: string]: Node };
  additionalFiles: { [index: string]: AdditionalFile };
  rightsRequest: RightsRequest;
  configuration: Configuration;
  currentApplicationUserRolesResult: CurrentApplicationUserRolesResult;
  dependantNodesByDataName: { [index: string]: string[] };
  orderedReferences: string[];
  localName: string;
  localDescription: string;
  localRefName: string;
  localRefDescription: string;

  constructor(applicationResult?: ApplicationResult) {
    this.id = applicationResult?.id ?? "";
    this.name = applicationResult?.name ?? "";
    this.title = applicationResult?.title ?? "";
    this.comment = applicationResult?.comment ?? "";
    this.configFile = applicationResult?.configFile ?? "";
    this.internationalization = applicationResult?.internationalization ?? {} as Internationalizations;
    this.data = applicationResult?.data ?? {};
    this.references = applicationResult?.references ?? {};
    this.authorizations = applicationResult?.authorizations ?? {};
    this.referenceSynthesis = applicationResult?.referenceSynthesis ?? [];
    this.dataTypes = applicationResult?.dataTypes ?? {};
    this.additionalFiles = applicationResult?.additionalFiles ?? {};
    this.rightsRequest = applicationResult?.rightsRequest ?? {} as RightsRequest;
    this.configuration = applicationResult?.configuration ?? {} as Configuration;
    this.currentApplicationUserRolesResult = applicationResult?.currentApplicationUserRolesResult ?? {} as CurrentApplicationUserRolesResult;
    this.dependantNodesByDataName = applicationResult?.dependantNodesByDataName ?? {};
    this.orderedReferences = applicationResult?.orderedReferences ?? [];
    this.localName = "";
    this.localDescription = "";
    this.localRefName = "";
    this.localRefDescription = "";
  }
}
